import * as React from 'react';

import CoursePage from './CoursePage'

import { Tooltip, } from '../../Shared/index'
import { READING_FOR_EVIDENCE_ACTIVITIES } from '../constants/contentHubs';

const chevronLeftImgSrc = `${window.postbuildEnv.CDN_URL}/images/icons/xs/chevron-left.svg`
const headerImgSrc = `${window.postbuildEnv.CDN_URL}/images/pages/content_hub/world_history_1750_to_present.jpg`

const imageCreditTooltipText = "<p><a href='https://upload.wikimedia.org/wikipedia/commons/8/84/Fran%C3%A7ois_d%27Orl%C3%A9ans_-_La_r%C3%A9volution_de_1830%2C_le_31_juillet.jpg' rel='noopener noreferrer' target='_blank'>\"La révolution de 1830, le 31 juillet\"</a> by François d'Orléans, prince de Joinville (1818-1900) is in the <a href='https://wiki.creativecommons.org/Public_domain' rel='noopener noreferrer' target='_blank'>Public Domain</a></p>"

const LOCAL_STORAGE_KEY = 'worldHistory1750ToPresentExpandedUnitTemplateIds'

const SLUG = 'world-history-1750-to-present'

const WorldHistory1750ToPresent = ({ backlinkPath, }) => {
  const contentPage = backlinkPath || window.location.href.split(SLUG)[0]
  const contentPageLink = <a className="quill-button medium outlined grey icon focus-on-light" href={contentPage}><img alt="" src={chevronLeftImgSrc} />View all social studies activities</a>

  const overviewSection = (
    <div className="overview">
      <div>
        <h1>World History: 1750 CE - Present</h1>
        <p className="overview-description">World history, or the story of our past, belongs to everyone: it helps us understand where we've come from, how we got here, and where we might go next. In this course, students explore that shared human story from the revolutions that shook the world in the 18th century to the rise of globalization today.</p>
        <p className="overview-description">Quill Reading for Evidence activities provide a deep dive into key moments and movements from the period spanning 1750 CE to the present, helping students expand their content knowledge while building core reading and writing skills.</p>
      </div>
      <div className="header-image-container">
        <img alt="" src={headerImgSrc} />
        <Tooltip tooltipText={imageCreditTooltipText} tooltipTriggerText="Image credit" tooltipTriggerTextClass="image-attribution-tooltip" />
      </div>
    </div>
  )

  const partnerSection = (
    <div className="partner-section">
      <h2>Paired with the OER Project for deeper learning</h2>
      <p>OER Project provides open educational resources to empower teachers to better serve their students through innovative curricula and teaching tools. Currently, OER Project offers three complete social studies courses: Big History Project (BHP), World History Project (WHP), and World History AP (WH AP). Each course includes primary and secondary source readings, videos, and learning activities, along with scaffolded supports like leveled texts. <a href="https://www.oerproject.com/World-History?WT.mc_id=00_00_2024__course-WHP_OER-QUILL_&WT.tsrc=OERQUILL" rel="noopener noreferrer" target="_blank">Learn more about OER Project’s World History Project</a>.</p>
      <a className="quill-button medium outlined grey focus-on-light" href={contentPage}>Learn More About Quill’s Social Studies Activities</a>
    </div>
  )

  return (
    <CoursePage
      activitiesHeader={READING_FOR_EVIDENCE_ACTIVITIES}
      contentPageLink={contentPageLink}
      localStorageKey={LOCAL_STORAGE_KEY}
      overviewSection={overviewSection}
      partnerSection={partnerSection}
      unitTemplatePath='/teachers/progress_reports/world_history_1750_to_present_unit_templates'
    />
  )
}

export default WorldHistory1750ToPresent
